import { useQuery } from '@tanstack/react-query';

import { dashboardOptions } from './dashboard.options';

export const useDashboard = () => {
  return useQuery(dashboardOptions.all());
};

export const useSharedDashboard = (shareToken: string | null) => {
  return useQuery(dashboardOptions.shared(shareToken));
};

export type { MarketApps } from '@/features/Dashboard/types';
